<div class="main">
  <spb-header/>
  <router-outlet></router-outlet>
  <div [style.flex]="1"></div>
  <spb-footer
    (logoutUser)="configService.reset()"
    [license]="true"
    [version]="version"
    [token]="configService.accessToken()"
    copyrightYears="2024"
  />
</div>